'use client';

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import MobileSearchResult, { MobileSearchResultSkeleton } from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/MobileSearchResult';
import SearchResult, { SearchResultSkeleton } from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/SearchResult';
import { BI_CATEGORY_SORT_AND_SEARCH, BI_EVENT_SEARCH_WORLD } from '@/constants/bi-sdk';
import { SEARCH_PARAM_KEYS } from '@/constants/search';
import { useBISdkContext } from '@/context/BISdkContext';
import { useUAContext } from '@/context/UAContext';
import { useIsMobile } from '@/hooks/useIsMobile';
export default function SearchContent() {
  const $ = _c(9);
  const {
    sendBIReport
  } = useBISdkContext();
  const {
    isMobileApp
  } = useUAContext();
  const isMobile = useIsMobile();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get(SEARCH_PARAM_KEYS.KEYWORD) ?? "";
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const urlSearchQuery = t0;
  let t1;
  let t2;
  if ($[2] !== sendBIReport || $[3] !== urlSearchQuery) {
    t1 = () => {
      sendBIReport({
        ev: BI_EVENT_SEARCH_WORLD,
        category: BI_CATEGORY_SORT_AND_SEARCH,
        a1: urlSearchQuery
      });
    };
    t2 = [sendBIReport, urlSearchQuery];
    $[2] = sendBIReport;
    $[3] = urlSearchQuery;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] !== isMobile || $[7] !== isMobileApp) {
    t3 = !isMobile && !isMobileApp ? <SearchResult /> : <MobileSearchResult />;
    $[6] = isMobile;
    $[7] = isMobileApp;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
export function SearchContentSkeleton() {
  const $ = _c(3);
  const isMobile = useIsMobile();
  const {
    isMobileApp
  } = useUAContext();
  let t0;
  if ($[0] !== isMobile || $[1] !== isMobileApp) {
    t0 = !isMobile && !isMobileApp ? <SearchResultSkeleton /> : <MobileSearchResultSkeleton />;
    $[0] = isMobile;
    $[1] = isMobileApp;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}